import React from 'react';
import { Container as UnstatedContainer } from 'unstated';
import { ScaleLoader,DotLoader} from 'react-spinners';
import { css } from '@emotion/core';
import myGlobals from '../Utils/globals';
import myUtilities, { CANADA_COUNTRY_CODE, DEFAULT_COUNTRY_CODE } from '../Utils/utils';
import * as DOMPurify from 'dompurify';
import { alertAlertAtion } from '../redux/actions/alertAction';
import { store as reduxStore } from "../redux/store";
import { callReduxForDropdownAlert } from '../App';
import { callReduxAlertAction } from '../App';
import { Row } from 'react-bootstrap';
import { PaymentElements } from '../Components/Payment';

class InvoiceDataContainer extends UnstatedContainer {
  checkForTopBuildTokens = (onSuccess,onFailure) => {
    const searchParams = new URLSearchParams();
    searchParams.append('token',myGlobals.token);
    let link = 'topBuildContext';
    link = myGlobals.initialHost+myGlobals.appender+link;
    //link = 'https://api.npoint.io/643ed9575b712189cc55';
    fetch(link, {

      method: 'POST',
      body: searchParams

    }).then(
      function(response){
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' +
            response.status);
            throw new Error('Status: '+response.status);
        }
        //console.log(response.text());
        return response.json();
      }
    ).then(function(data){
      onSuccess(data);
    }).catch(
      function(err)
      {
        console.log('Fetch Error :-S',err);
        onFailure(err);
      }
    );


  }
  setPayableAmount = async (amount) => {
    this.setState({
      total: parseFloat(amount).toFixed(2),
      payableAmount: amount
    });
  }
  topBuildResponseHandler = async (data) => {
    if(data.rows.context!==undefined){
      let token = myGlobals.token;
      let accountLogo = "/radiusoneweb/securedFileDownload?file="+data.rows.accountLogo+'&token='+encodeURIComponent(token)+'&src=logo';
      myGlobals.globalAccountId = data.rows.globalAccountId.toString();
      myGlobals.poaCurrencies = data.rows.poaCurrencies.toString();
      myGlobals.selectedPoaCurrency = data.rows.poaCurrencies.toString().split(',')[0];
      await this.setState({
        globalAccountId: data.rows.globalAccountId,
        accountLogo: accountLogo,
        token: token,
        context: data.rows.context,
        pkMcarId: data.rows.pkMcarId,
        loading: false
      });
      myGlobals.getHistory.replace(`/mainapp`);
    }
    else {
        this.initiateIdealFlow();
    }
  }
  setRemittanceDetails = (data) => {
    const keys = Object.keys(data);
    let myState = '{"remittanceFormData":{';
    for(let i=0;i<keys.length;++i){
      if(keys[i].toString().localeCompare('fields')===0)
        continue;
      let value = data[keys[i]];
      myState+='"'+keys[i]+'":"'+value+'",';
    }
    myState=myState.substring(0,myState.length-1);
    myState+='}}';
    this.setState(JSON.parse(myState));
  }
  initiateIdealFlow = () => {
    let link = "getInvoicesToPay";
    myGlobals.ajaxCall(myGlobals.initialHost+myGlobals.appender+link,null,'POST',(data)=>{this.populateData(data)},this.failedToPopulateData, myGlobals.token);
    
    //let str='{	"results": 1,	"rows": {	"isDiscEnabled":"true",	"trustlyEnabled": "true",		"giropayEnabled": "true",		"idealEnabled": "false",		"bancontactEnabled": "false",  "paypalEnabled": "true",		"showPaymentContracts": "true",	"achAgreementType": "",	 "ccAgreementType": "html",  "ACHAgreementpath": "<html><button>Click me</button></html>",		"CCAgreementpath": "https://www.goal.com/en-in",		"currency": "USD",		"invoices": [{			"invoiceNumber": "6798130891234567890123451",			"payableAmount": 235,			"accountDocHeaderId": 15299463,			"currency": "USD",			"paymentStatus": "Open",			"disputeAmount": "0",			"discountAmount": 3.9,			"reasonCodeId": ""		},{			"invoiceNumber": "6798130891234567890123451",			"payableAmount": 235,			"accountDocHeaderId": 15299463,			"currency": "USD",			"paymentStatus": "Open",			"disputeAmount": "0",			"discountAmount": 3.9,			"reasonCodeId": ""		},{			"invoiceNumber": "6798130891234567890123451",			"payableAmount": 235,			"accountDocHeaderId": 15299463,			"currency": "USD",			"paymentStatus": "Open",			"disputeAmount": "0",			"discountAmount": 3.9,			"reasonCodeId": ""		}, {			"invoiceNumber": "6798130891234567890123451",			"payableAmount": 9867,			"accountDocHeaderId": 15299463,			"currency": "USD",			"paymentStatus": "Open",			"disputeAmount": "0",			"discountAmount": 7.0,			"reasonCodeId": ""		}],		"isACHEnabled": "true",		"isCCEnabled": "true",		"accountLogo": "static/assets/img/Radiusone_Logo_Before_Login - TM.png",		"onDemandAccountId": 20359,		"pkMcarId": 105980855,		"publicKey": "9995362445e0a98f4da3019f6f3eb960f938056972408675c0b3f642ad5943709f8e8031f00bba6ed24bad1e8e2b099cd154b5eb5b64b310d179b39abb4392442cdb8ad3fe8bc6e3088bd63089d405fb134c633de62b741e4c5bd615b90e096ec3bb16f71ef54825febc5662a96c093db986225825a1cc63d4dc19e2abbbfb1cb9d3a5e41f757ce3f82481a5caf92207ffe4c37e8acc43835dce49cf61a6b113384d333050b6ac59ef78a182bae114b08729e84cbad659eb8bace0481aa51a370daac09f97d779be245ce95af85a285d0ea170da732f9eef2e43a21f5586014ea00259ef09498356eaf2d4e492f0f8978ca167c3f690b35045a8dd1c7ccf4347",		"globalAccountId": 295	},	"success": true,	"customValues": {},	"excludeCalsess": null}';
    //this.populateData(JSON.parse(str));
  }
  constructor(props){
    super(props);
    this.checkForTopBuildTokens((data)=>{this.topBuildResponseHandler(data)},this.initiateIdealFlow);
  }
  state={
    accountLogo: "https://i.ibb.co/SJ1Rtbj/wayne-Enterprises-Logo.jpg",
    topbuildloading: false,
    loading: true,
    isAchEnabled: null,
    isCCEnabled: null,
    remittanceFormData: null,
    defaultLanguageCode: 'en',
    currency: 'USD',
    showStaticLoading: false,
    showMissingReasonAlert: false,
    showInvalidAmountAlert: false,
    invalidAmountAlertMessage: ''
  };
  validateAndPopulateSupplierLogo = () => {
    if(this.state.loading){
      const override = css`
          display: block;
          margin: 0 auto;
      `;
      return (<DotLoader
        css={(window.screen.width<=575?override:null)}
        size={50}
        sizeUnit={"px"}
        color={'#000000'}
        loading={true}
      />);
    }
    else
      return this.state.accountLogo;
  }
  isMoreThanThreeInvoices = () => {
    if(this.state.count>3 && this.state.gridFields)
      return true;
    else
      return false;
  }
  getInvoices = () => {
    return this.state.invoices;
  }
   getSelectedInvoices = () => {
    return this.state.selectedInvoices;
  };
  
  sumofArray = (sum, num) => parseFloat(sum) + parseFloat(num);
  
   generateSelectedIndices = () => {
    let selList = this.state.selectedInvoices?.map((invoice) => invoice.accountDocHeaderId);
    let invoiceList = this.state.invoices?.map((invoice) => invoice.accountDocHeaderId);
    let indices = [];

    for (let i = 0; i < invoiceList?.length; ++i) {
      if (selList.includes(invoiceList[i])) indices.push(i);
    }

    return indices;
  };
  
  updateSelectedInvoices = (selectedIndices, triggerTempAlert) => {
    let selInvoices = [];
    for (let i = 0; i < selectedIndices.length; ++i) {
      selInvoices.push(this.state.invoices[selectedIndices[i]]);
    }
  
    let selCount = selectedIndices.length;
    let selTotal = selInvoices
      .map((invoice) => invoice.payableAmount)
      .reduce(this.sumofArray);
    let discountTotal = selInvoices
      .map((invoice) => invoice.discountAmount)
      .reduce(this.sumofArray);
    let totalValWithoutDiscount = selTotal;
    discountTotal = parseFloat(parseFloat(discountTotal).toFixed(2));
    discountTotal = isNaN(discountTotal) ? 0 : discountTotal;
    selTotal = (selTotal - discountTotal).toFixed(2);

    if (totalValWithoutDiscount < 0) {
      triggerTempAlert('Alert.TotalPayableAmountCheck', 'Total payable amount cannot be less than 0');
    }
    else {
      this.setState({
        selectedInvoices: selInvoices,
        count: selCount,
        total: selTotal,
        totalDiscVal: discountTotal,
        totalValWithoutDiscount: totalValWithoutDiscount
      });
    }
  };


	  updateDeselectedInvoices = (selectedIndices, triggerTempAlert) => {
		
	    let selInvoices = [];
	    if(selectedIndices.length>0){
	       selInvoices.push(this.state.invoices[selectedIndices[0]]);
	    }
	
	    let selCount = selInvoices.length;
	    let selTotal = selInvoices
	      .map((invoice) => invoice.payableAmount)
	      .reduce(this.sumofArray);
	    let discountTotal = selInvoices
	      .map((invoice) => invoice.discountAmount)
	      .reduce(this.sumofArray);
	    let totalValWithoutDiscount = selTotal;
	    discountTotal = parseFloat(parseFloat(discountTotal).toFixed(2));
	    discountTotal = isNaN(discountTotal) ? 0 : discountTotal;
	    selTotal = (selTotal - discountTotal).toFixed(2);
	    
      if (totalValWithoutDiscount < 0) {
        triggerTempAlert('Alert.TotalPayableAmountCheck', 'Total payable amount cannot be less than 0');
      }
      else {
	    this.setState({
	      selectedInvoices: selInvoices,
	      count: selCount,
	      total: selTotal,
	      totalDiscVal: discountTotal,
	      totalValWithoutDiscount: totalValWithoutDiscount
	    });
    }
		
	  };
  
  
    toggleSelctedInvoices = (triggerTempAlert) => {
    if(this.state.selectedInvoices.length !== this.state.invoices.length) {
      this.updateSelectedInvoices(Array.from(Array(this.state.invoices.length).keys()), triggerTempAlert)
    }else{
	      this.updateDeselectedInvoices(Array.from(Array(this.state.invoices.length).keys()), triggerTempAlert)
    }
  }
  
  validateAndPopulateData = (obj,loadingSize) => {
    if(this.state.loading)
    return (<ScaleLoader
                    
                    sizeUnit={"px"}
                    height={loadingSize}
                    color={'#000000'}
                    loading={true}
    />);
    else
    {
        if(this.state.hasOwnProperty(obj))
        { if(obj == "total"){
            return myUtilities.needCurrency("total")+  myUtilities.toStringUtil( this.state[obj],"total");
          }else{
              return  this.state[obj];
          }
        }
      }
  }  
  populateGridMetaData = (fields,layout) => {
    let fieldArray=[];
    for(let i=0;i<fields.length;++i){
      console.log(fields);
      let row = fields[i].split(',');
      row.splice(2,row.length-2);
      let rank = layout.indexOf(row[0]);
      row.rank = rank;
      if(row.rank!==-1)
        fieldArray.push(row);
    }
    fieldArray.sort((a,b)=>{return a.rank-b.rank});
    this.setState({
      gridFields: fieldArray
    });
  }
  validateAndPopulateInvoiceData = (index,obj,loadingSize,reqType) => {
    if(this.state.loading)
    return (<ScaleLoader
                    
                    sizeUnit={"px"}
                    height={loadingSize}
                    color={'#000000'}
                    loading={true}
    />);
    else if (reqType==='complete') {
      if(this.state.invoices.length>0 && this.state.invoices[index].hasOwnProperty(obj))
        return (this.state.invoices[index])[obj];
    } else {
      if(this.state.selectedInvoices.length>0 && this.state.selectedInvoices[index].hasOwnProperty(obj))
        return (this.state.selectedInvoices[index])[obj];
    }
  }
  getTotalDiscountAmount =(invoices)=>{
    if(myGlobals.isDiscountEnabled){
      let totalDisc=0;
      for(let i=0;i<invoices.length;++i){
        if((invoices[i])['discountAmount']!==undefined && (invoices[i])['discountAmount']!==null)
        totalDisc+=parseFloat((invoices[i])['discountAmount']);
      }
      console.log(totalDisc);
      return totalDisc;
    }else
      return 0;
  }
  getTotalInvoiceAmount = (invoices) => {
    let totalVal;
    if(this.state.paymentOnAccount===true)
      {
        totalVal = parseFloat(this.state.payableAmount);
      }
    else{
      totalVal = 0;
      for(let i=0;i<invoices.length;++i){
        const currentAmt = (invoices[i]['payableAmount'] !== undefined && invoices[i]['payableAmount'] !== null)
        ? invoices[i]['payableAmount']
        : invoices[i]['payableAmount2'];
      totalVal += parseFloat(currentAmt || 0);
      }
    }
    return totalVal.toFixed(2);
  }
  applyPartialPaymentTotal = () => {
    let newTotal = this.getTotalInvoiceAmount(this.state.selectedInvoices);
    const discVal = parseFloat(this.state.totalDiscVal || 0);
    newTotal = (parseFloat(newTotal) - discVal).toFixed(2);
    this.setState({ total: newTotal });
  }
  insertCurrencySymbol = () => {
    if(this.state.currency.localeCompare('USD')===0){
      myGlobals.globalCurrencySymbol='$';
    }else if(this.state.currency.localeCompare('EUR')===0){
        myGlobals.globalCurrencySymbol='€';
    }else if(this.state.currency.localeCompare('GBP')===0){
        myGlobals.globalCurrencySymbol='£';
    }else{
      myGlobals.globalCurrencySymbol=this.state.currency + " ";
    }
    return this.state.currency;
  }
  checkInvoicesHaveBlockedStatus = (invoices) => {
      let flag = false;
      invoices.forEach((invoice)=>{
        let status = invoice['paymentStatus'];
        if(myGlobals.blockedStatuses.has(status))
            flag = true;
      });
      return flag;
  }

  getGridMetaDataResponseHandler = (data) => {
      let fields;
      let layout;
      
      if(data.rows.gridFields!==undefined && data.rows.layoutList!==undefined){
        layout = data.rows.layoutList.split('&');
        layout = JSON.parse(layout[1]).data.split(',');
        console.log(myGlobals.isDiscountEnabled);
        if(!myGlobals.isDiscountEnabled){
          if(layout.includes("discountAmount")){
           layout.splice(layout.indexOf("discountAmount"),1);
          }
        }
        fields = data.rows.gridFields.split('^');
        layout.splice(4,layout.length-6);
        this.populateGridMetaData(fields,layout);
      }
  }

  getGridMetaMeta = () => {
      if(window.rsaEncrypt===undefined){
        setTimeout(this.getGridMetaMeta,5000);
        return;
      }
      const searchParams = new URLSearchParams();
      searchParams.append('dataTypeId',77777);
      searchParams.append('fieldLevel',1);
      searchParams.append('payThroughEmail',true);
      searchParams.append('accountId',this.state.globalAccountId);
      searchParams.append('layoutFor',1101);
      searchParams.append('partialPaymentEnabledForGuestPay', this.state.partialPaymentEnabledForGuestPay === true);
      
      let link = "getInvoiceGridMetaData";
    let responseHandler = this.getGridMetaDataResponseHandler;
    link = myGlobals.initialHost+myGlobals.appender+link;
    //link = 'https://api.npoint.io/e61e88068a0ddc6c7813'
    fetch(link, {
      method: 'POST',
      body: searchParams

    }).then(
      function(response){
        if (response.status !== 200) {
          console.log('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }
    ).then(function(data){
      responseHandler(data);
    }).catch(
      function(err)
      {
        console.log('Fetch Error :-S',err);
        
      }
    );
  }

    deriveDefaultCountryCode = (achCountryDropdownValues) => {
    if (
      achCountryDropdownValues === undefined ||
      !Array.isArray(achCountryDropdownValues)
    ) {
      return DEFAULT_COUNTRY_CODE;
    }
    if (achCountryDropdownValues.includes(DEFAULT_COUNTRY_CODE))
      return DEFAULT_COUNTRY_CODE;
    if (achCountryDropdownValues.includes(CANADA_COUNTRY_CODE))
      return CANADA_COUNTRY_CODE;
    return DEFAULT_COUNTRY_CODE;
  };

  modifyValueForDropdown = financialInstitutionDetails => {

    if(financialInstitutionDetails === undefined || 
        financialInstitutionDetails === '' || 
        typeof financialInstitutionDetails !== 'object')
      return '';

    let displayDropodwon = [];

    for(let finItem in financialInstitutionDetails) {
      displayDropodwon.push({
        "id": finItem,
        "name": financialInstitutionDetails[finItem][1]
      })
    }

    return displayDropodwon;

  }

  populateData = async (data) => {

  if(data.rows !== undefined){
  
  		let allowInvoiceExclusion = data.rows.hasOwnProperty("allowInvoiceExclusion") ? data.rows.allowInvoiceExclusion === "true" : false;
        let globalAccountId = data.rows.globalAccountId;
        myGlobals.invoiceSelectionAllowed = allowInvoiceExclusion;
        myGlobals.globalAccountId = data.rows.globalAccountId.toString();
        myGlobals.paymentLimitsMap = data.rows.paymentLimits;
        let onDemandAccountId = data.rows.onDemandAccountId;
        let isAchEnabled = false;
        let isPMTDIEnabled = false;
        let isCCEnabled = false;
        let isSurchargeEnabledOnCC = false;
        let isSurchargeEnabledOnCardBrand = false;
        let isSurchargeThroughAPIEnabled = false;
        let isLateFeeEnabled = false;
        let failed = false;
        let isDCEnabled = false;
        let ACHAgreementpath = data.rows.ACHAgreementpath;
        let CCAgreementpath = data.rows.CCAgreementpath;
        let showPaymentContracts = true;
        let totalValWithoutDiscount;
        let achAgreementType = data.rows.achAgreementType;
        let ccAgreementType = data.rows.ccAgreementType;
        let DCAgreementpath = data.rows.DCAgreementpath;
        let dcAgreementType = data.rows.dcAgreementType;
        let DC_routingBasedOnPaymentInstrument =
          data.rows.DC_routingBasedOnPaymentInstrument;
        let CC_routingBasedOnPaymentInstrument =
          data.rows.CC_routingBasedOnPaymentInstrument;
        let bankTransferConfigFields = (data.rows.bankTransferConfigFields !== undefined && 
        		data.rows.bankTransferConfigFields !== null && 
        		data.rows.bankTransferConfigFields !== "" ) ? data.rows.bankTransferConfigFields : [];


        let achMandatoryFieldsList = [];
        let partialPaymentEnabledForGuestPay = false;

        bankTransferConfigFields.forEach((field) => {
          if (field.fieldType.toLowerCase() == "input") {
            achMandatoryFieldsList.push(
              <Row>
                <PaymentElements
                  name={DOMPurify.sanitize(field.eippFieldDisplayName)}
                  header={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        field.eippFieldMlKey,
                        field.eippFieldDisplayName
                      )}
                      {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                    </div>
                  }
                  key={field.eippFieldDisplayName}
                  isMandateField
                  isRequiredField={DOMPurify.sanitize(field.isMandatory)}
                  customValidationRegex={DOMPurify.sanitize(field.validationRegex)}
                  customValidationMessage={DOMPurify.sanitize(field.validationMessage)}
                  customValidationMessageMLKey={DOMPurify.sanitize(field.validationMessageMlKey)}
                />
              </Row>
            );
          } else if (field.fieldType.toLowerCase() == "inputdropdown") {
            achMandatoryFieldsList.push(
              <Row>
                <PaymentElements
                  name={field.eippFieldDisplayName}
                  header={
                    <div>
                      {myUtilities.accountSpecificLanguage(
                        field.eippFieldMlKey,
                        field.eippFieldDisplayName
                      )}
                      {field.isMandatory ? <span className="red-asterisk">*</span> : null}
                    </div>
                  }
                  key={field.eippFieldDisplayName}
                  isEIPPDropdown={true}
                  dropdownStoreName={field.eippDbColumn + ".BankFields"}
                  isMandateField
                />
              </Row>
            );
          }
        });

 	  let defaultAchAccountType = data.rows.defaultAchAccountType;
      
      if(defaultAchAccountType === undefined || defaultAchAccountType === '')
        defaultAchAccountType = 'Savings';
      let achCountryDropdownValues =
        data.rows.achCountryDropdownValues !== undefined &&
        Array.isArray(data.rows.achCountryDropdownValues)
          ? data.rows.achCountryDropdownValues
          : ["US"];

      let defaultCountryCode = this.deriveDefaultCountryCode(
        achCountryDropdownValues
      );

      let financialInstitutionDetails = data.rows.financialInstitutionDetails;
      let financialInstitutionDropdown = this.modifyValueForDropdown(financialInstitutionDetails);
        
	      let toShowTncForPayment = {
	        'ach' : achAgreementType === "staticLink" || achAgreementType === "html" || achAgreementType === "s3Path",
	        'cc' : ccAgreementType === "staticLink" || ccAgreementType === "html" || ccAgreementType === "s3Path",
	        'dc' : dcAgreementType === "staticLink" || dcAgreementType === "html" || dcAgreementType === "s3Path"
	      };
        
        myGlobals.amountFormat = data.rows.amountFormat;
        myGlobals.PPRO_TNC_INFO = data.rows.PPRO_TNC_INFO;
        
        if(data.rows.showPaymentContracts!==undefined && data.rows.showPaymentContracts!==null && data.rows.showPaymentContracts.toString().toLowerCase().localeCompare('false')===0){
          showPaymentContracts = false;
        }
        if(data.rows.isACHEnabled.toString().toLowerCase().localeCompare('true')===0)
          isAchEnabled = true;
        if(data.rows.isPMTDIEnabled!==undefined && data.rows.isPMTDIEnabled.toString().toLowerCase().localeCompare('true')===0)
          isPMTDIEnabled = true;
        if(data.rows.isCCEnabled.toString().toLowerCase().localeCompare('true')===0)
          isCCEnabled = true;
        if(data.rows.isSurchargeEnabledOnCC && data.rows.isSurchargeEnabledOnCC.toString().toLowerCase().localeCompare('true')===0)
            isSurchargeEnabledOnCC = true;
        if(data.rows.isSurchargeEnabledOnCardBrand && data.rows.isSurchargeEnabledOnCardBrand.toString().toLowerCase().localeCompare('true')===0)
          isSurchargeEnabledOnCardBrand = true;
        if(data.rows.isSurchargeThroughAPIEnabled && data.rows.isSurchargeThroughAPIEnabled.toString().toLowerCase().localeCompare('true')===0)
          isSurchargeThroughAPIEnabled = true;
        if(data.rows.isLateFeeEnabled && data.rows.isLateFeeEnabled.toString().toLowerCase().localeCompare('true')===0)
          isLateFeeEnabled = true;
        if(data.rows.isDCEnabled && data.rows.isDCEnabled.toString().toLowerCase().localeCompare('true')===0)
          isDCEnabled = true;
        if(data.rows.partialPaymentEnabledForGuestPay && data.rows.partialPaymentEnabledForGuestPay.toString().toLowerCase().localeCompare('true')===0){
          partialPaymentEnabledForGuestPay = true;
        }
        let showFrequentMethods = (isAchEnabled || isCCEnabled || isDCEnabled);
        let pkMcarId = data.rows.pkMcarId;
        let paymentOnAccount = data.rows.paymentOnAccount;
        if(undefined!==paymentOnAccount && paymentOnAccount.toString().localeCompare('true')===0)
          paymentOnAccount = true;
        else
          paymentOnAccount = false;         

        let processorName = data.rows.processorName;
        let countVal;
        let payableAmount= this.state.payableAmount;
        let minAmount;
        let maxAmount;
        let invoices;
        let totalVal;
        let totalDiscVal;
        let deletedInvoices='';
        let currency = data.rows.currency;
        let discountAmount= data.rows.discountAmount;
        let isDiscEnabled = false;
        if(data.rows.isDiscEnabled !== undefined && data.rows.isDiscEnabled.toString().toLowerCase().localeCompare('true')===0){
          isDiscEnabled = true;
        }
        myGlobals.isDiscountEnabled = isDiscEnabled;
        let SEPA = false;
        let trustlyEnabled = false;
        let giropayEnabled = false;
        let idealEnabled = false;
        let bancontactEnabled = false;
        let paypalEnabled = false;
        let additionalParams=[];
        if(data.rows.trustlyEnabled.toString().toLowerCase().localeCompare('true')===0)
          trustlyEnabled = true;
        if(data.rows.giropayEnabled.toString().toLowerCase().localeCompare('true')===0)
          giropayEnabled = true;
        if(data.rows.idealEnabled.toString().toLowerCase().localeCompare('true')===0)
          idealEnabled = true;
        if(data.rows.bancontactEnabled.toString().toLowerCase().localeCompare('true')===0)
          bancontactEnabled = true;
        if(data.rows.paypalEnabled!==null && data.rows.paypalEnabled!==undefined && data.rows.paypalEnabled.toString().toLowerCase().localeCompare('true')===0)
          paypalEnabled = true;
        let showAdditionalMethods = true;
        if(!trustlyEnabled && !giropayEnabled && !idealEnabled && !bancontactEnabled)
          showAdditionalMethods = false;

          if(!showFrequentMethods && !showAdditionalMethods){
            failed = true;
            myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.InvalidPaymentModes", "No payment modes available for payment")
          }
        if(currency===undefined){
          failed = true;
          myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.InvalidCurrency", "No valid currency");
        }
        if(!paymentOnAccount){
          if(currency.localeCompare('EUR')===0){
            SEPA = true;
          }
          invoices = data.rows.invoices;
          if((invoices===null || invoices===undefined) && (paymentOnAccount===undefined || paymentOnAccount.toString().toLowerCase().localeCompare('false')===0)){
            failed=true;
            myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.MissingInvoices", "Missing Invoices")
          }
          else {
            countVal = invoices.length;
            for(let i=0;i<invoices.length;++i){
              if(parseFloat(invoices[i].payableAmount)===parseFloat(0) || myGlobals.blockedStatuses.has(invoices[i]['paymentStatus'])){
                deletedInvoices+=invoices[i].invoiceNumber+',';
                invoices.splice(i,1);
                --i;
              }
            }
            totalDiscVal = this.getTotalDiscountAmount(invoices);
            console.log("totaldiscount value is "+totalDiscVal);
            totalVal = this.getTotalInvoiceAmount(invoices);
            totalValWithoutDiscount = totalVal;
            if(totalVal<=0){
              failed = true;
              myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.InvalidInvoices", "You have no valid invoices to pay")
            }
            if(myGlobals.isDiscountEnabled){
              totalVal = parseFloat(totalVal)-parseFloat(totalDiscVal);
              totalVal = totalVal.toFixed(2);
            }
            if(deletedInvoices.length>0){
              deletedInvoices = deletedInvoices.substring(0,deletedInvoices.length-1);
            }
            countVal = invoices.length;
            invoices.map((invoice)=>{
              invoice.payableAmount2=invoice.payableAmount;
              invoice.disputeAmount2=parseFloat(invoice.disputeAmount).toFixed(2);
              invoice.payableAmount=invoice.payableAmount.toFixed(2);
              if(myGlobals.isDiscountEnabled){
                if(invoice.discountAmount!==null){
                  invoice.discountAmount = parseFloat(invoice.discountAmount).toFixed(2);
                }else{
                  invoice.discountAmount = parseFloat(0).toFixed(2); 
                }
              }
              return invoice;
            });
          }
        }
        else{
          if(this.state.payableAmount===undefined){
            payableAmount = data.rows.payableAmount;
          }
          if(data.rows.minAmount===undefined || data.rows.maxAmount===undefined){
            minAmount = parseFloat(0);
            maxAmount = parseFloat(0);
          }
          else{
            minAmount = parseFloat(data.rows.minAmount);
            maxAmount = parseFloat(data.rows.maxAmount);
          }
          if(parseFloat(payableAmount)<=0){
            failed = true;
            myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.NegativePayableAmount", "Payable Amount should be positive");
          }
          if(Number.isNaN(minAmount) || Number.isNaN(maxAmount)){
            failed = true;
            myGlobals.errorMessage="Invalid min and max amounts";
          }
          if(data.rows.additionalParams!==undefined)
            additionalParams = data.rows.additionalParams;
        }
        window.pubkey = data.rows.publicKey;
        let token = myGlobals.token;
        let accountLogo = "/radiusoneweb/securedFileDownload?file="+data.rows.accountLogo+'&token='+encodeURIComponent(token)+'&src=logo';
        
        if(paymentOnAccount){
          await this.setState({
            total:payableAmount,
            currency: currency,
            payableAmount: payableAmount,
            minAmount: minAmount,
            maxAmount: maxAmount,
            paymentOnAccount: paymentOnAccount,
            globalAccountId:globalAccountId,
            onDemandAccountId:onDemandAccountId,
            pkMcarId:pkMcarId,
            accountLogo: accountLogo,
            loading: false,
            token: myGlobals.token,
            publicKey: data.rows.publicKey,
            failed: failed,
            isAchEnabled: isAchEnabled,
            isPMTDIEnabled: isPMTDIEnabled,
            isCCEnabled:isCCEnabled,
            context: undefined,
            ACHAgreementpath: ACHAgreementpath,
            CCAgreementpath: CCAgreementpath,
            showPaymentContracts: showPaymentContracts,
            trustlyEnabled: trustlyEnabled,
            giropayEnabled: giropayEnabled,
            idealEnabled: idealEnabled,
            bancontactEnabled: bancontactEnabled,
            showAdditionalMethods: showAdditionalMethods,
            showFrequentMethods: showFrequentMethods,
            additionalParams: additionalParams,
            paypalEnabled : paypalEnabled,
            achAgreementType : achAgreementType,
            ccAgreementType : ccAgreementType,
            isDCEnabled: isDCEnabled,
            DCAgreementpath: DCAgreementpath,
            dcAgreementType : dcAgreementType,
            isSurchargeEnabledOnCC: isSurchargeEnabledOnCC,
            isSurchargeEnabledOnCardBrand: isSurchargeEnabledOnCardBrand,
            isSurchargeThroughAPIEnabled:isSurchargeThroughAPIEnabled,
            isLateFeeEnabled: isLateFeeEnabled,
            bankTransferConfigFields : bankTransferConfigFields,
            achMandatoryFieldsList : achMandatoryFieldsList,
            processorName: processorName,
            toShowTncForPayment,
            DC_routingBasedOnPaymentInstrument,
            CC_routingBasedOnPaymentInstrument,
            resetNum:0,
            achCountryDropdownValues,
            defaultCountryCode,
            financialInstitutionDropdown,
            financialInstitutionDetails,
            defaultAchAccountType
          });
        }
        else{
          await this.setState({
            count:countVal,
            total:totalVal,
            totalDiscVal : totalDiscVal,
            deletedInvoices: deletedInvoices,
            currency: currency,
            invoices: invoices,
            paymentOnAccount: paymentOnAccount,
            globalAccountId:globalAccountId,
            onDemandAccountId:onDemandAccountId,
            pkMcarId:pkMcarId,
            accountLogo: accountLogo,
            loading: false,
            token: myGlobals.token,
            publicKey: data.rows.publicKey,
            failed: failed,
            isAchEnabled: isAchEnabled,
            isPMTDIEnabled: isPMTDIEnabled,
            isCCEnabled:isCCEnabled,
            context: undefined,
            isSepa:SEPA,
            ACHAgreementpath: ACHAgreementpath,
            CCAgreementpath: CCAgreementpath,
            showPaymentContracts: showPaymentContracts,
            trustlyEnabled: trustlyEnabled,
            giropayEnabled: giropayEnabled,
            idealEnabled: idealEnabled,
            bancontactEnabled: bancontactEnabled,
            showAdditionalMethods: showAdditionalMethods,
            showFrequentMethods: showFrequentMethods,
            paypalEnabled: paypalEnabled,
            achAgreementType : achAgreementType,
            ccAgreementType : ccAgreementType,
            selectedInvoices: invoices,
            allowInvoiceExclusion: allowInvoiceExclusion,
            isDCEnabled: isDCEnabled,
            DCAgreementpath: DCAgreementpath,
            dcAgreementType : dcAgreementType,
            isSurchargeEnabledOnCC: isSurchargeEnabledOnCC,
            isSurchargeEnabledOnCardBrand: isSurchargeEnabledOnCardBrand,
            isSurchargeThroughAPIEnabled: isSurchargeThroughAPIEnabled,
            isLateFeeEnabled: isLateFeeEnabled,
            isDiscEnabled:isDiscEnabled,
            bankTransferConfigFields : bankTransferConfigFields,
            achMandatoryFieldsList : achMandatoryFieldsList,
            processorName: processorName,
            toShowTncForPayment,
            totalValWithoutDiscount,
            DC_routingBasedOnPaymentInstrument,
            CC_routingBasedOnPaymentInstrument,
            resetNum:0,
            achCountryDropdownValues,
            defaultCountryCode,
            financialInstitutionDropdown,
            financialInstitutionDetails,
            defaultAchAccountType,
            partialPaymentEnabledForGuestPay: partialPaymentEnabledForGuestPay
          });
          if (partialPaymentEnabledForGuestPay) {
            this.fetchDisputeConfig();
          }
          this.getGridMetaMeta();
        }
        myGlobals.getHistory.replace(`/mainapp`);
      }
      else{
      myGlobals.failureReason = data.results;
      myGlobals.globalAccountId = data.globalAccountId;
	  console.log('printing failure reason');
	  console.log(myGlobals.failureReason);

	  if(myGlobals.failureReason == 'LINK_EXPIRED'){
		  myGlobals.errorMessage = myUtilities.accountSpecificLanguage("Error.LinkExpired", "Link has expired");
		  await this.setState({
			  failedLink : true,
		  });
		  myGlobals.getHistory.replace(`/linkExpired`);
	  }
	  else if(myGlobals.failureReason == 'GUEST_PAY_NOT_ENABLED'){
		 myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.GuestPayNotEnabled", "Guest pay not enabled"); 
		 await this.setState({
			  failedGPNotEnabled : true,
		  });
		  myGlobals.getHistory.replace(`/invalidConfig`);
	  }
	  else{
		 myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.InvalidToken", "Invalid token");
		 await this.setState({
			  failedInvalidToken : true,
		  });
		  myGlobals.getHistory.replace(`/invalidConfig`);
	  }
      }
  }
  failedToPopulateData = async () => {
    myGlobals.errorMessage=myUtilities.accountSpecificLanguage("Error.InvalidLink", "Invalid Link");
    await this.setState({
      failed:true
    });
    myGlobals.getHistory.replace(`/error`);
  }
  storeTotalAmount =(amount) =>{
    this.setState({
      payableAmount:amount
    })
  }

  fetchDisputeConfig = () => {
    const searchParams = new URLSearchParams();
    searchParams.append('onDemandAccountId', this.state.onDemandAccountId);
    const link = myGlobals.initialHost + myGlobals.appender + 'getEIPPDisputeConfig';
    fetch(link, { method: 'POST', body: searchParams })
      .then(res => res.json())
      .then(data => {
        const twoLevelReasonCodeEnabled = data.rows && data.rows[0] && data.rows[0].twoLevelReasonCodeEnabled;
        this.setState({ twoLevelReasonCodeEnabled: !!twoLevelReasonCodeEnabled });
        if (twoLevelReasonCodeEnabled) {
          this.fetchReasonCategories();
        } else {
          this.fetchReasonCodes(null);
        }
      })
      .catch(err => console.log('fetchDisputeConfig error:', err));
  }

  fetchReasonCategories = () => {
    const searchParams = new URLSearchParams();
    searchParams.append('onDemandAccountId', this.state.onDemandAccountId);
    searchParams.append('showpartialPayment', 'True');
    const link = myGlobals.initialHost + myGlobals.appender + 'getDisputeReasonCategoryById';
    fetch(link, { method: 'POST', body: searchParams })
      .then(res => res.json())
      .then(data => {
        this.setState({ reasonCategories: data.rows || [] });
      })
      .catch(err => console.log('fetchReasonCategories error:', err));
  }

  fetchReasonCodes = (categoryId) => {
    const searchParams = new URLSearchParams();
    searchParams.append('onDemandAccountId', this.state.onDemandAccountId);
    let link;
    if (categoryId) {
      searchParams.append('selectedReasonCodeCategoryId', categoryId);
      link = myGlobals.initialHost + myGlobals.appender + 'getDisputeReasonCodeById';
    } else {
      link = myGlobals.initialHost + myGlobals.appender + 'getDisputeReasonCode';
    }
    fetch(link, { method: 'POST', body: searchParams })
      .then(res => res.json())
      .then(data => {
        this.setState({ reasonCodes: data.rows || [] });
      })
      .catch(err => console.log('fetchReasonCodes error:', err));
  }

  updateInvoicePartialPayment = (accountDocHeaderId, field, value) => {
    this.setState((prevState) => {
      const invoices = prevState.invoices.map((inv) => {
        if (inv.accountDocHeaderId !== accountDocHeaderId) return inv;
        const updated = { ...inv, [field]: value };
        if (field === 'payableAmount') {
          const original = parseFloat(inv.payableAmount2 !== undefined ? inv.payableAmount2 : inv.payableAmount);
          if (parseFloat(value) >= original) {
            updated.partialPaymentReasonCategory = '';
            updated.partialPaymentReason = '';
            updated.partialPaymentComments = '';
          }
        }
        return updated;
      });
      const selectedInvoices = prevState.selectedInvoices.map((inv) => {
        if (inv.accountDocHeaderId !== accountDocHeaderId) return inv;
        return invoices.find(i => i.accountDocHeaderId === accountDocHeaderId);
      });
      return { invoices, selectedInvoices };
    });
  }

  // Snapshot the editable partial-payment fields before the "Edit Invoices"
  snapshotPartialPaymentState = () => {
    this.editSnapshot = {
      invoices: this.state.invoices.map((inv) => ({ ...inv })),
      selectedInvoices: this.state.selectedInvoices.map((inv) => ({ ...inv })),
      total: this.state.total,
      totalDiscVal: this.state.totalDiscVal,
      reasonCodes: this.state.reasonCodes,
      reasonCategories: this.state.reasonCategories,
    };
  };

  // Restore the fields captured by snapshotPartialPaymentState, discarding any edits made while the popup was open.
  restorePartialPaymentSnapshot = () => {
    if (!this.editSnapshot) return;
    this.setState({
      invoices: this.editSnapshot.invoices,
      selectedInvoices: this.editSnapshot.selectedInvoices,
      total: this.editSnapshot.total,
      totalDiscVal: this.editSnapshot.totalDiscVal,
      reasonCodes: this.editSnapshot.reasonCodes,
      reasonCategories: this.editSnapshot.reasonCategories,
    });
    this.editSnapshot = null;
  };
  
   cardResponseHandler = async (data, payData) => {
    if (
      data &&
      data.rows &&
      data.rows[0].totalConvienceFee >= 0 &&
      data.rows[0].totalSurchargeAmount >= 0
    ) {

      let lateFee = payData.state.totalLateFee !== null ? payData.state.totalLateFee : 0;
      let isPOA = this.state.paymentOnAccount;
      console.log("Is POA -> " + isPOA);
      let totalAmt = this.getTotalInvoiceAmount(this.state.selectedInvoices);
      let surcharge =
        data.rows[0].totalSurchargeAmount > 0
          ? data.rows[0].totalSurchargeAmount
          : 0;
      let taxOnSurcharge =
        data.rows[0].totalTaxOnSurcharge > 0
          ? data.rows[0].totalTaxOnSurcharge
          : 0;
      let convFee =
        data.rows[0].totalConvienceFee > 0 ? data.rows[0].totalConvienceFee : 0;
      let discountValue =
        myGlobals.isDiscountEnabled && this.state.totalDiscVal !== null
          ? this.state.totalDiscVal
          : 0;
          
      if (!isPOA) {
        totalAmt = parseFloat(totalAmt) + parseFloat(lateFee) - parseFloat(discountValue);
      } else {
        totalAmt = parseFloat(totalAmt) - parseFloat(discountValue);
      }
      
      totalAmt =
        parseFloat(totalAmt) + parseFloat(convFee) + parseFloat(surcharge) + parseFloat(taxOnSurcharge);      

      totalAmt = parseFloat(totalAmt).toFixed(2);
      await payData.setTotalConvenienceFeeAndSurcharge(
        convFee === 0 ? null : convFee.toFixed(2),
        surcharge === 0 ? null : surcharge.toFixed(2)
      );

        if(data.rows[0]?.isSurchargeApplicableForTransaction){
          await this.setState({isSurchargeApplicableForTransaction: data.rows[0]?.isSurchargeApplicableForTransaction});
        }
        if(data.rows[0]?.surchargePOEDisclosure){
          await this.setState({surchargePOEDisclosure: data.rows[0]?.surchargePOEDisclosure});
        }
        if(data.rows[0]?.surchargeSummaryDTOs){
          await this.setState({surchargeSummaryDTOs: data.rows[0]?.surchargeSummaryDTOs});
        }
      await this.setState({total: totalAmt, toLoadCardDI: true, multipleTransactionsPerMID: (data?.customValues?.multipleTransactionsPerMID)? "true": "false"});
      
    } else {
	 	if(data?.rows && data?.customValues?.errorCode) {
	        if(data.customValues.errorCode == "8015" || data.customValues.errorCode == "8014" || data.customValues.errorCode == "8013" || data.customValues.errorCode == "8012" || data.customValues.errorCode == "8011") {
	          if(!payData.state.isDCFlow)
	          {
	            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsgCC", "The selected invoices require additional authentication and cannot be paid together using a Credit Card.");
	          }
	          else
	          {
	            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsgDC", "The selected invoices require additional authentication and cannot be paid together using a Debit Card.");
	          }
	        }
	        else if(data.customValues.errorCode == "8010") {
	          if(!payData.state.isDCFlow)
	          {
	            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsg8010CC", "Some of the selected invoices require additional authentication and cannot be paid together using a Credit Card.");
	          }
	          else
	          {
	            callReduxAlertAction("Error.GuestPay3dsPmidCombinationMsg8010DC", "Some of the selected invoices require additional authentication and cannot be paid together using a Debit Card.");
	          }
	        }
	        else if(data.customValues.errorCode == "7087") {
	                callReduxAlertAction("Error.InvalidPmidCombinationMsg", data.rows);
	        }
      }
      {myUtilities.accountSpecificLanguage(
        'CreditCard.Error.NotEligible',
        'Not eligible for CC payment'
      )}
    }
    
  };

  onDiscountSuccess = async (data, paymentData, postBackFunc, type='') => {
    if (data != undefined && data != null) {
      let discountValue = parseFloat(data.rows.discount);
      console.log(discountValue);
      let totalAmt = this.getTotalInvoiceAmount(
        this.state.selectedInvoices
      );
      console.log(totalAmt);
      totalAmt = parseFloat(totalAmt) - discountValue;
      if (paymentData.state.totalConvienceFee !== null) {
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(paymentData.state.totalConvienceFee);
      }
      if (paymentData.state.totalSurchargeAmount !== null) {
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(paymentData.state.totalSurchargeAmount);
      }
      if (paymentData.state.totalLateFee !== null) {
        totalAmt =
          parseFloat(totalAmt) +
          parseFloat(paymentData.state.totalLateFee);
      }
      totalAmt = parseFloat(totalAmt).toFixed(2);
      console.log(totalAmt);
      await this.setState({
        totalDiscVal: discountValue,
        total: totalAmt,
        lastAppliedTotal: totalAmt,
        lastAppliedDiscVal: discountValue,
      });
      postBackFunc(this, paymentData, type);
    }
  };


  makeDiscountOrLateFeeCallForPaymentMethod = async (paymentData, paymentMethod, postBackFunc=()=>{}) => {
    let token = this.state.token;
    const searchParams = new URLSearchParams();
    searchParams.append("token", token);
    let invoiceNumbers = "";
    let partialPaymentAmounts = "";
    this.state.selectedInvoices.forEach((invoice) => {
      invoiceNumbers += invoice.accountDocHeaderId + ",";
      const originalAmount = parseFloat(invoice.payableAmount2 !== undefined ? invoice.payableAmount2 : invoice.payableAmount);
      const currentAmount = parseFloat(invoice.payableAmount);
      // Only send an override when the user has actually reduced the amount (partial payment).
      if (!Number.isNaN(currentAmount) && !Number.isNaN(originalAmount) && currentAmount > 0 && currentAmount < originalAmount) {
        partialPaymentAmounts += invoice.accountDocHeaderId + ":" + currentAmount + ",";
      }
    });
    invoiceNumbers = invoiceNumbers.substring(0, invoiceNumbers.length - 1);
    if (partialPaymentAmounts.length > 0) {
      partialPaymentAmounts = partialPaymentAmounts.substring(0, partialPaymentAmounts.length - 1);
    }
    searchParams.append("invoiceNumbers", invoiceNumbers);
    searchParams.append("partialPaymentAmounts", partialPaymentAmounts);
    if (paymentMethod === "cc") {
		  paymentMethod = "CREDITCARD";
    } else if (paymentMethod === "dc") {
      paymentMethod = "DEBITCARD";
    } else if (paymentMethod === "ach") {
      paymentMethod = "ACH";
    } else {
      console.log("Payment method not cc or dc or ach -> " + paymentMethod);
    }
    console.log(paymentMethod);
    searchParams.append("paymentMethod", paymentMethod);
    let link = "getPmtMethodBasedDiscount";
    link = myGlobals.initialHost + myGlobals.appender + link;
    
    fetch(link, {
      //"https://gist.githubusercontent.com/gokuafrica/53a8cf6f81f9eca632dfa241a148378b/raw/d9de7b9c47d12f551c015aa8dc81742478c680d0/test"
      method: "POST",
       body: searchParams,
    })
      .then(function (response) {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          throw new Error("Status: " + response.status);
        }
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data != null && data.rows != null) {
          let discount = parseFloat(data.rows.discount);
          if (isNaN(discount)) {
            data.rows.discount = 0;
          }
          let totalLateFee = parseFloat(data.rows.totalLateFee);
          
          if (isNaN(totalLateFee)) {
            data.rows.totalLateFee = 0;
          }

          // setting totalLateFee in paymentData state
          paymentData.state.totalLateFee = data.rows.totalLateFee;

          this.onDiscountSuccess(data, paymentData, postBackFunc, paymentMethod);
        }
      })
      .catch( (err) => {
        console.log("Fetch Error for discounts:-S", err);
        reduxStore.dispatch(
          alertAlertAtion({
            message: "Fetching discount based on payment method failed",
            id: "failure.generic.discount.alert",
            additionalItems: [],
          })
        );
      });
  }
  makeDropdownCallForCardTypes = async (paymentMethod) => {
    
    await this.setState({showStaticLoading: true});
    const searchParams = new URLSearchParams();
    searchParams.append("token", this.state.token);
    searchParams.append("paymentMethod", paymentMethod);
    searchParams.append("languageCode", myGlobals.languageCode);

    let link = "getCardTypesForDropdown";
    link = myGlobals.initialHost + myGlobals.appender + link;

    await fetch(link, {
      method: "POST",
      body: searchParams,
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log(
            "Looks like there was a problem. Status Code: " + response.status
          );
          throw new Error("Status: " + response.status);
        }
        return response.json();
      })
      .then(async data => {
        await this.setState({
          cardTypesDropdown: data.rows.dropDownValues,
        });
        await this.setState({showStaticLoading: false});
        callReduxForDropdownAlert();
      })
      .catch(err => {
        console.log("Fetch Error for dropdown:-S", err);
        this.setState({showStaticLoading: false});
        this.setState({
          cardTypesDropdown: {},
        });
      });
  };

  triggerMissingReasonAlert = () => {
    this.setState({ showMissingReasonAlert: true });
    setTimeout(() => {
      this.setState({ showMissingReasonAlert: false });
    }, 3000);
  };

  validatePartialPaymentReasons = () => {
    const selectedInvoices = this.state.selectedInvoices || [];
    const isTwoLevel = this.state.twoLevelReasonCodeEnabled === true;
    let isMissing = false;

    for (let inv of selectedInvoices) {
      const originalAmt = parseFloat(inv.payableAmount2 !== undefined ? inv.payableAmount2 : inv.payableAmount);
      const currentAmt = parseFloat(inv.payableAmount);

      // Trigger validation if payment amount is reduced
      if (currentAmt < originalAmt) {
        const isCategoryMissing = isTwoLevel && (!inv.partialPaymentReasonCategory || inv.partialPaymentReasonCategory.trim() === "");
        const isReasonMissing = !inv.partialPaymentReason || inv.partialPaymentReason.trim() === "";

        // Trigger alert if either dropdown is missing
        if (isCategoryMissing || isReasonMissing) {
          isMissing = true;
          break;
        }
      }
    }

    if (isMissing) {
      this.triggerMissingReasonAlert();
      return false;
    }

    return true;
  };

  validatePayableAmountsOnApply = () => {
    const selectedInvoices = this.state.selectedInvoices || [];
    let hasInvalid = false;
    let firstInvalidOriginal = null;

    for (let inv of selectedInvoices) {
      const original = parseFloat(inv.payableAmount2 !== undefined ? inv.payableAmount2 : inv.payableAmount);
      if (!(original > 0)) continue;

      const userEnteredValue = parseFloat(inv.payableAmount);
      const isInvalid = Number.isNaN(userEnteredValue) || userEnteredValue <= 0 || userEnteredValue > original;

      if (isInvalid) {
        if (firstInvalidOriginal === null) firstInvalidOriginal = original;
        hasInvalid = true;
        this.updateInvoicePartialPayment(inv.accountDocHeaderId, 'payableAmount', original.toFixed(2));
      }
    }

    if (hasInvalid) {
      const message = `The payable amount should be between 0.1 and ${firstInvalidOriginal.toFixed(2)}.`;
      this.triggerInvalidAmountAlert(message);
      return false;
    }
    return true;
  }

  triggerInvalidAmountAlert = (message) => {
    this.setState({ showInvalidAmountAlert: true, invalidAmountAlertMessage: message });
    setTimeout(() => {
      this.setState({ showInvalidAmountAlert: false, invalidAmountAlertMessage: '' });
    }, 3000);
  }
}

export default InvoiceDataContainer;